import {dayUseNavigationMenuNames} from './get-dayuse-navigation-id-and-values';
import {getMultiRoomKey, setRoomSelectionObject} from './common-utils';

export const isValidRouteForCalendarAndTimeScreen = page => {
  if (!page) {
    return false;
  }

  return [
    dayUseNavigationMenuNames.home,
    dayUseNavigationMenuNames.srp,
    dayUseNavigationMenuNames.seosrp,
    dayUseNavigationMenuNames.goSuggest,
    dayUseNavigationMenuNames.detail,
  ].includes(page);
};

export const isValidRouteToShowDestination = page => {
  if (!page) {
    return false;
  }

  return [
    dayUseNavigationMenuNames.srp,
    dayUseNavigationMenuNames.goSuggest,
    dayUseNavigationMenuNames.seosrp,
  ].includes(page);
};
